export class EjendomsfaktorDefinitionValgmulighedDto {
    public id: string;
    public navn: string;
}
